
import { ChartPie as ChartPieIcon } from '@phosphor-icons/react/dist/ssr/ChartPie';
import { GearSix as GearSixIcon } from '@phosphor-icons/react/dist/ssr/GearSix';
import { PlugsConnected as PlugsConnectedIcon } from '@phosphor-icons/react/dist/ssr/PlugsConnected';
import { User as UserIcon } from '@phosphor-icons/react/dist/ssr/User';
import { Users as UsersIcon } from '@phosphor-icons/react/dist/ssr/Users';
import { XSquare } from '@phosphor-icons/react/dist/ssr/XSquare';
import { List } from '@phosphor-icons/react/dist/ssr';
import { Timer } from '@phosphor-icons/react/dist/ssr';
import { Video, ListChecks } from '@phosphor-icons/react/dist/ssr';
import { Scroll, BookOpenText, GraduationCap, Student, UsersFour, Link, TrendUp } from '@phosphor-icons/react';
import myActivitySvg from '../assets/svgs/menuIcons/myActivity.svg';
import quizPocSvg from '../assets/svgs/menuIcons/quizPoc.svg';
import studySvg from '../assets/svgs/menuIcons/study.svg';
import questionBankSvg from '../assets/svgs/menuIcons/questionBank.svg';
import courseIconSvg from '../assets/svgs/menuIcons/courseIcon.svg';
import irGradingIconSvg from '../assets/svgs/menuIcons/irGradingIcon.svg';
import assessmentIconSvg from '../assets/svgs/menuIcons/assessmentIcon.svg';
import gradingModelSvg from '../assets/svgs/menuIcons/gradingModel.svg';
import speechConfigSvg from '../assets/svgs/menuIcons/speechConfig.svg';
import diagnosticSvg from '../assets/svgs/menuIcons/diagnostic.svg';

export const navIcons = {
  'chart-pie': ChartPieIcon,
  'gear-six': GearSixIcon,
  'plugs-connected': PlugsConnectedIcon,
  'x-square': XSquare,
  user: UserIcon,
  users: UsersIcon,
  list: List,
  timer: Timer,
  video: courseIconSvg,
  'list-checks': assessmentIconSvg,
  Scroll: questionBankSvg,
  'book-open-text': studySvg,
  'graduation-cap': gradingModelSvg,
  'Student': quizPocSvg,
  'ir-grading': irGradingIconSvg,
  'users-four': quizPocSvg,
  'trend-up': myActivitySvg,
  config: speechConfigSvg,
  diagnostic: diagnosticSvg,
  'teacher-dashboard': ChartPieIcon,
  'teacher-student-tracking': UsersFour,
}